import React from "react";
import { Link } from "react-router-dom";
import Text from "@/components/ui/text";
import IconContainer from "@/components/ui/icon-container";
import Skeleton from "@/components/ui/skeleton";
import { ChevronRight } from "@dreamhub/designsystem/icons";
import { cn } from "@/utils/utils";

export interface NavigationItem {
  label: string;
  to?: string;
  isActive?: boolean;
}

export interface SettingsNavigationProps {
  items: NavigationItem[];
  isLoading?: boolean;
  className?: string;
}

const SettingsNavigation: React.FC<SettingsNavigationProps> = ({
  items,
  isLoading = false,
  className = ""
}) => {
  if (isLoading) {
    return (
      <div className={cn("flex items-center gap-5", className)}>
        {items.map((_, index) => (
          <Skeleton key={index} className="h-6 w-[5.5rem]" />
        ))}
      </div>
    );
  }

  return (
    <div className={cn("flex items-center", className)}>
      {items.map((item, index) => (
        <React.Fragment key={index}>
          {item.to && !item.isActive ? (
            <Link to={item.to}>
              <Text className="px-1 py-[2px]" variant="bodyTertiary">
                {item.label}
              </Text>
            </Link>
          ) : (
            <Text
              className="px-1 py-[2px]"
              variant={item.isActive ? "body" : "bodyTertiary"}
            >
              {item.label}
            </Text>
          )}
          {index < items.length - 1 && (
            <IconContainer color="tertiary">
              <ChevronRight />
            </IconContainer>
          )}
        </React.Fragment>
      ))}
    </div>
  );
};

export default SettingsNavigation;
